import { render, staticRenderFns } from "./TermsConditionCheckbox.vue?vue&type=template&id=6172adb4"
import script from "./TermsConditionCheckbox.vue?vue&type=script&lang=js"
export * from "./TermsConditionCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports